      
import React from 'react';

import {useDispatch, useSelector} from 'react-redux';
import {removeFromCart} from './actions/index.js';

import {connect} from 'react-redux'
// import { addToCart } from './actions/index.js';




function DisplayCart(props){
    // const dispatch = useDispatch();

    // const allOrders = useSelector(state => state.orderList)
    const allOrders = props.data.reducer.orderList
    
    const orders = allOrders.filter( (ele, ind) => ind === allOrders.findIndex( elem => elem.name === ele.name && elem.id === ele.id))

    var price = 0;
    Object.keys(orders).map(item => (
        price += orders[item].quantity*orders[item].price
    ))

    // console.log("Reducer",orders)
    // const removeFromBasket = (item) => {
        // removeFromCart(dispatch, item)
    // }

    return (
        <div>
            <h3 id='myCart'>My Cart</h3>

            {orders && Object.keys(orders).map(item => (
                <div  className='flex-row wrap'>
                    <p id={'productName'+ orders[item].id}>{orders[item].name}</p>
                    <p id={'productQuantity'+orders[item].id}>{orders[item].quantity}</p>
                    <p id={'productPrice'+orders[item].id}>{String("$" + orders[item].price)}</p>
                    <button id={'removeButton'+orders[item].id} onClick={() => props.removeFromBasket(orders[item])}>X</button>
                </div>
            ))}
        

            <div id='totalPrice'>
                Total Price: ${price}
            </div>
        </div>
    )
}


const mapStateToProps=state=>({
    data: state
})
const mapDispatchToProps=dispatch=>({
    removeFromBasket:data=>dispatch(removeFromCart(data))

})
export default connect(mapStateToProps,mapDispatchToProps)(DisplayCart)
